import React from "react";

import { Endpoint } from "@schneiderpp/admin-endpoint";
import { BaseComponent } from "../../utils/BaseComponent";
import { Link, withRouter, RouteComponentProps } from "react-router-dom";
import { OverlayProps, Overlay } from "@schneiderpp/utils-components";
import { ParentStateDatasource, DataSourceStateIdle } from "@schneiderpp/utils-endpoint";
import { ds } from "../../DataSource";
import { ROUTER_HOME } from "../home/Router";

interface SalesmanListState {
    datasource: {
        List: ParentStateDatasource<typeof Endpoint.Salesman.GetSalesmanList>;
    };
}

class List extends BaseComponent<RouteComponentProps, SalesmanListState> {
    state: SalesmanListState = {
        datasource: {
            List: DataSourceStateIdle
        }
    };

    private dsList = ds(Endpoint.Salesman.GetSalesmanList, this, "List", () => this.context);

    componentDidMount() {
        this.getList();
    }

    render() {
        return (
            <div className="page">
                <div className="page__header">Lista Handlowców</div>
                <div className="page-buttons">
                    <Link to={ROUTER_HOME.Salesman.Add} className="button small">
                        Dodaj Handlowca
                    </Link>
                </div>
                <div className="page-table">
                    <table className="table">
                        <thead>
                            <tr>
                                <th className="w-6 t-left">Nazwa</th>
                                <th className="w-6">Email</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.salesmanList.map((salesman) => (
                                <tr
                                    className="clickable"
                                    key={salesman.SalesmanId}
                                    onClick={() =>
                                        this.props.history.push({
                                            pathname: ROUTER_HOME.Salesman.Details.About,
                                            search: `SalesmanId=${salesman.SalesmanId}`
                                        })
                                    }
                                >
                                    <td className="t-left">{salesman.Name}</td>
                                    <td className="t-center">{salesman.Email}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <Overlay {...this.overlayProps} />
            </div>
        );
    }

    get salesmanList() {
        const dsListData = this.dsList.dataSourceStorage;
        if (dsListData.state === "completed") {
            return dsListData.response.salesmans;
        }
        return [];
    }

    get overlayProps(): OverlayProps {
        if (this.dsList.state === "pending") {
            return {
                show: true,
                title: "Ładowanie...."
            };
        }
        if (this.dsList.state === "error") {
            return {
                show: true,
                title: "Coś poszło nie tak",
                description: typeof this.dsList.error === "string" ? this.dsList.error : "",
                children: (
                    <div className="overlay__children">
                        <button onClick={() => this.getList()} className="button light">
                            Spróbuj ponownie
                        </button>
                    </div>
                )
            };
        }
        return {
            show: false
        };
    }

    private getList() {
        this.dsList.request({});
    }
}

export default withRouter(List);
